import service_auth from '../../services/auth'


export const login = async ({commit}, payload) => {
    try{
        let {data} = await service_auth.login(payload)
        if (data.token) {
            commit('setUser', data.user)
            commit('setAccessToken', data.token)
            return Promise.resolve(data)
        } else {
            return Promise.reject({data: {error: 'Ups algo salio mal'}})
        }
    } catch(err) {
        return Promise.reject(err)
    }
}